import React, { useState, useContext } from "react";
import { SetPopup } from '../../../components/set-popup/SetPopup';
import { Loader } from "../../../components/loader/Loader";
import DownloadAccessCodes from "./DownloadAccessCodes";
import EmailAccessCodes from "./EmailAccessCodes";
import { AppContext } from "../../../App";
import "./DownloadOrEmailCodesModal.scss";
const DownloadOrEmailCodesModal = ({ 
        actionType = "", 
        isOpen = false, 
        onCloseHanlder = () => { }, 
        currentRequestId = "", 
        accessCodeOrderStatus = "" 
    }) => {

    const {
         errorPopup, 
         translate: t, 
         unAuthorizedErrorMessage
    } = useContext(AppContext);

    const [isLoading, setLoading] = useState(false);

    const onError = (error) => {  // function to handle error status
        if (error && error.status === 403) {
            errorPopup.setState(unAuthorizedErrorMessage);
        }
        else if (error && error.status === 404) {
            errorPopup.setState({});
            return;
        }
        else {
            errorPopup.setState({
                isOpen: true,
                heading: t("Oops!! Something went wrong"),
                info: t(`Unable to fetch details.`),
                btnName: t("Okay, Got it"),
                buttonAction: () => errorPopup.setVisibility(false),
                btnStyle: false,
                image: `${process.env.PUBLIC_URL}/images/error-browser.svg`,
                onClosePopup: () => errorPopup.setVisibility(false)
            })
        }
        errorPopup.setVisibility(true);
    }

    const modalContent = () => {
        return (
            <div className="action-modal-content">
                <div className={`download-email-modal ${actionType}`}>
                    {actionType === "download" &&
                        <div className="download-access-codes-section">
                            <DownloadAccessCodes 
                                setLoading={setLoading} 
                                onError={onError} 
                                currentRequestId={currentRequestId} 
                                accessCodeOrderStatus={accessCodeOrderStatus}
                            />
                        </div>
                    }
                    {actionType === "email" &&
                        <div className="email-access-codes-section">
                            <EmailAccessCodes 
                                setLoading={setLoading} 
                                onError={onError} 
                                currentRequestId={currentRequestId} 
                                accessCodeOrderStatus={accessCodeOrderStatus}
                                />
                        </div>
                    }
                </div>
            </div>)
    }
    return (
        <>
            {isLoading && <Loader />}
            <SetPopup 
                isOpen={isOpen} 
                closePopup={onCloseHanlder}
                subInfo={modalContent()}
                className={`action-modal-${actionType}`}
            >
            </SetPopup>
        </>
    )
}

export default DownloadOrEmailCodesModal;
